import type { InboxCatalogueEntry } from "./documentInbox";

export function trainingExpiryPolicy(options: InboxCatalogueEntry[] | undefined, id: unknown) {
  const entry = options?.find((option) => option.id === id);
  return { required: entry?.expiry_required ?? false, months: entry?.suggested_validity_months ?? null, review: entry?.expiry_review_required ?? true };
}

/** Calendar months, clamped to the last valid day of the target month. */
export function suggestTrainingExpiry(issued: string | null | undefined, months: number | null): string {
  if (!issued || !/^\d{4}-\d{2}-\d{2}$/.test(issued) || months === null || !Number.isInteger(months) || months <= 0) return "";
  const [year, month, day] = issued.split("-").map(Number) as [number, number, number];
  const original = new Date(Date.UTC(year, month - 1, day));
  if (original.toISOString().slice(0, 10) !== issued) return "";
  const end = new Date(Date.UTC(year, month + months, 0));
  const result = new Date(Date.UTC(end.getUTCFullYear(), end.getUTCMonth(), Math.min(day, end.getUTCDate())));
  return result.toISOString().slice(0, 10);
}
